import { FC, useMemo } from "react";

import BillAvatar from "@images/bill.png";
import { HiCheck } from "react-icons/hi";
import Image from "next/legacy/image";
import MyhanhAvatar from "@images/myhanh.png";
import HusseinAvatar from "@images/hussein.png";
import { Typography } from "@earned/core";
import { themeTextColors } from "@common/constants";

interface Props {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  teamMember: Record<string, string | any>;
}

const AdvisorTeamMember: FC<Props> = ({ teamMember }) => {
  const teamMemberAvatar = useMemo(() => {
    switch (teamMember.name) {
      case "Hussein Elgohary":
        return HusseinAvatar;
      case "Bill Martin":
        return BillAvatar;
      case "Myhanh Hoskin":
      default:
        return MyhanhAvatar;
    }
  }, [teamMember]);

  return (
    <div className="border-y border-primary bg-offwhite p-6 opacity-70 lg:h-[324px] lg:min-w-[250px] lg:rounded-lg lg:border-x">
      <div className="flex flex-row justify-between lg:flex-col">
        <div className="h-16 w-16 flex-none">
          <Image
            src={teamMemberAvatar}
            alt="profile picture"
            width={64}
            height={64}
            className="rounded-full shadow-sm grayscale"
          />
        </div>
        <div className={`ml-6 w-full lg:ml-0 lg:mt-2`}>
          <Typography variant="body-xl" color="disabled" weight="medium">
            {teamMember.name}
          </Typography>
          <div className="block h-10">
            <Typography variant="body" color="disabled" weight="medium">
              {teamMember.position && teamMember.position}
            </Typography>
          </div>
          <div className="flex flex-col gap-1">
            {teamMember.help.map((element: string, index: number) => (
              <div
                key={`${index}-${element}`}
                className="flex flex-row gap-1.5"
              >
                <HiCheck size={16} color={themeTextColors.disabled} />
                <Typography variant="body-xs" color="disabled">
                  {element}
                </Typography>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
export default AdvisorTeamMember;
